<template>
  <div class="customer-ortho-iprs">

    <customer-show-ortho-ipr ref="showipr" :customer="customer" @submit="loadIPRs"></customer-show-ortho-ipr>

    <!-- ODONTOGRAM ROW -->
    <div class="customer-ortho-iprs__info">
      <strong>Selecciona una pieza para resaltar los IPR relacionados o selecciona un IPR para ver sus valores
        aislados</strong>
      <div>
        <transition name="fade">
          <button v-if="active_selection" @click="clearSelected" class="btn btn-wabident-round mx-1">
            <i class="fas fa-undo"></i> Borrar selección
          </button>
        </transition>
        <button @click="createIPR" class="btn btn-wabident-round mx-1">
          <i class="fas fa-plus"></i>
          Crear IPR
        </button>
      </div>
    </div>
    <div class="customer-ortho-iprs__odontogram">
      <!-- UPPER ROW -->
      <div class="customer-ortho-iprs__odontogram-row">
        <div v-for="tooth, index in upper_row_teeth" :key="index" :data-tooth="tooth" @click="clickTooth(tooth)"
          class="customer-ortho-iprs__odontogram-tooth upper" :class="{ selected: isSelected(tooth) }">
          <img :src="'/odontogram-v2/' + tooth + '.svg'">

          <div v-if="upper_totals_left[tooth]" class="customer-ortho-iprs__tooth-totals upper left">
            {{ upper_totals_left[tooth] }}
          </div>

          <div v-if="upper_totals[tooth]" class="customer-ortho-iprs__tooth-totals upper">
            {{ upper_totals[tooth] }}
          </div>

          <div v-if="upper_totals_right[tooth]" class="customer-ortho-iprs__tooth-totals upper right">
            {{ upper_totals_right[tooth] }}
          </div>

        </div>
      </div>
      <!-- LOWER ROW -->
      <div class="customer-ortho-iprs__odontogram-row">
        <div v-for="tooth, index in lower_row_teeth" :key="index" :data-tooth="tooth" @click="clickTooth(tooth)"
          class="customer-ortho-iprs__odontogram-tooth lower" :class="{ selected: isSelected(tooth) }">
          <img :src="'/odontogram-v2/' + tooth + '.svg'">

          <div v-if="lower_totals_left[tooth]" class="customer-ortho-iprs__tooth-totals lower left">
            {{ lower_totals_left[tooth] }}
          </div>

          <div v-if="lower_totals[tooth]" class="customer-ortho-iprs__tooth-totals lower">
            {{ lower_totals[tooth] }}
          </div>

          <div v-if="lower_totals_right[tooth]" class="customer-ortho-iprs__tooth-totals lower right">
            {{ lower_totals_right[tooth] }}
          </div>


        </div>
      </div>
    </div>
    <!-- ipr LIST -->
    <div class="customer-ortho-iprs__list">
      <table class="table table-search-results">
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Superior</th>
            <th>Inferior</th>
            <th>Notas</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <customer-ortho-ipr @edit="editIPR" @select="clickIpr" @delete="deleteIPR" :selected_tooth="selected_tooth"
            :selected_ipr="selected_ipr" v-for="ipr in ortho_iprs" :key="ipr.id" :customer="customer"
            :ipr="ipr"></customer-ortho-ipr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ['customer'],
  data() {
    return {
      selected_ipr: null,
      selected_tooth: 0,
      upper_row_adults: [
        18, 17, 16, 15, 14, 13, 12, 11, // UPPER LEFT
        21, 22, 23, 24, 25, 26, 27, 28, // UPPER RIGHT
      ],
      lower_row_adults: [
        48, 47, 46, 45, 44, 43, 42, 41, // LOWER LEFT
        31, 32, 33, 34, 35, 36, 37, 38, // LOWER RIGHT
      ],
      upper_row_keys: {
        // UPPER LEFT
        '18': '18-17',
        '17': '17-16',
        '16': '16-15',
        '15': '15-14',
        '14': '14-13',
        '13': '13-12',
        '12': '12-11',
        '11': '11-21',
        // UPPER RIGHT
        '21': '21-22',
        '22': '22-23',
        '23': '23-24',
        '24': '24-25',
        '25': '25-26',
        '26': '26-27',
        '27': '27-28',
        '28': null,
      },
      upper_row_keys_left: {
        // UPPER LEFT
        '18': '18-Izq',
        '17': '17-Izq',
        '16': '16-Izq',
        '15': '15-Izq',
        '14': '14-Izq',
        '13': '13-Izq',
        '12': '12-Izq',
        '11': '11-Izq',
        // UPPER RIGHT
        '21': '21-Izq',
        '22': '22-Izq',
        '23': '23-Izq',
        '24': '24-Izq',
        '25': '25-Izq',
        '26': '26-Izq',
        '27': '27-Izq',
        '28': '28-Izq',
      },
      upper_row_keys_right: {
        // UPPER LEFT
        '18': '18-Dcha',
        '17': '17-Dcha',
        '16': '16-Dcha',
        '15': '15-Dcha',
        '14': '14-Dcha',
        '13': '13-Dcha',
        '12': '12-Dcha',
        '11': '11-Dcha',
        // UPPER RIGHT
        '21': '21-Dcha',
        '22': '22-Dcha',
        '23': '23-Dcha',
        '24': '24-Dcha',
        '25': '25-Dcha',
        '26': '26-Dcha',
        '27': '27-Dcha',
        '28': '28-Dcha',
      },
      lower_row_keys: {
        // LOWER LEFT
        '48': '48-47',
        '47': '47-46',
        '46': '46-45',
        '45': '45-44',
        '44': '44-43',
        '43': '43-42',
        '42': '42-41',
        '41': '41-31',
        // LOWER RIGHT
        '31': '31-32',
        '32': '32-33',
        '33': '33-34',
        '34': '34-35',
        '35': '35-36',
        '36': '36-37',
        '37': '37-38',
        '38': null,
      },
      lower_row_keys_left: {
        // LOWER LEFT
        '48': '48-Izq',
        '47': '47-Izq',
        '46': '46-Izq',
        '45': '45-Izq',
        '44': '44-Izq',
        '43': '43-Izq',
        '42': '42-Izq',
        '41': '41-Izq',
        // LOWER RIGHT
        '31': '31-Izq',
        '32': '32-Izq',
        '33': '33-Izq',
        '34': '34-Izq',
        '35': '35-Izq',
        '36': '36-Izq',
        '37': '37-Izq',
        '38': '38-Izq',
      },
      lower_row_keys_right: {
        // LOWER LEFT
        '48': '48-Dcha',
        '47': '47-Dcha',
        '46': '46-Dcha',
        '45': '45-Dcha',
        '44': '44-Dcha',
        '43': '43-Dcha',
        '42': '42-Dcha',
        '41': '41-Dcha',
        // LOWER RIGHT
        '31': '31-Dcha',
        '32': '32-Dcha',
        '33': '33-Dcha',
        '34': '34-Dcha',
        '35': '35-Dcha',
        '36': '36-Dcha',
        '37': '37-Dcha',
        '38': '38-Dcha',
      },
      iprs: [],
    }
  },
  computed: {
    active_selection() {
      return Boolean(this.selected_tooth) || Boolean(this.selected_ipr);
    },
    ortho_iprs() {
      return this.iprs;
    },
    filtered_iprs() {
      if (this.selected_ipr) {
        return this.ortho_iprs.filter((ipr) => {
          return ipr.id == this.selected_ipr;
        });
      }

      return this.ortho_iprs;
    },
    upper_row_teeth() {
      return this.upper_row_adults;
    },
    lower_row_teeth() {
      return this.lower_row_adults;
    },
    /* Computed Totals For Tooth */
    /* LOWER ARCH INTER-TOOTH VALUES */
    lower_totals() {
      let ret = {};
      this.lower_row_teeth.forEach((tooth) => {
        const pair_key = this.lower_row_keys[tooth] || null;
        if (pair_key) {
          const pair_value = this.ipr_lower_totals[pair_key] || null;
          if (pair_value) {
            ret[tooth] = pair_value;
          }
        }
      });
      return ret;
    },
    /* LOWER ARCH LEFT */
    lower_totals_left() {
      let ret = {};
      this.lower_row_teeth.forEach((tooth) => {
        const pair_key = this.lower_row_keys_left[tooth] || null;
        if (pair_key) {
          const pair_value = this.ipr_lower_totals[pair_key] || null;
          if (pair_value) {
            ret[tooth] = pair_value;
          }
        }
      });
      return ret;
    },
    /* LOWER ARCH RIGHT */
    lower_totals_right() {
      let ret = {};
      this.lower_row_teeth.forEach((tooth) => {
        const pair_key = this.lower_row_keys_right[tooth] || null;
        if (pair_key) {
          const pair_value = this.ipr_lower_totals[pair_key] || null;
          if (pair_value) {
            ret[tooth] = pair_value;
          }
        }
      });
      return ret;
    },
    /* UPPER ARCH INTER-TOOTH */
    upper_totals() {
      let ret = {};
      this.upper_row_teeth.forEach((tooth) => {
        const pair_key = this.upper_row_keys[tooth] || null;
        if (pair_key) {
          const pair_value = this.ipr_upper_totals[pair_key] || null;
          if (pair_value) {
            ret[tooth] = pair_value;
          }
        }
      });
      return ret;
    },
    /* UPPER ARCH LEFT */
    upper_totals_left() {
      let ret = {};
      this.upper_row_teeth.forEach((tooth) => {
        const pair_key = this.upper_row_keys_left[tooth] || null;
        if (pair_key) {
          const pair_value = this.ipr_upper_totals[pair_key] || null;
          if (pair_value) {
            ret[tooth] = pair_value;
          }
        }
      });
      return ret;
    },
    /* UPPER ARCH RIGHT */
    upper_totals_right() {
      let ret = {};
      this.upper_row_teeth.forEach((tooth) => {
        const pair_key = this.upper_row_keys_right[tooth] || null;
        if (pair_key) {
          const pair_value = this.ipr_upper_totals[pair_key] || null;
          if (pair_value) {
            ret[tooth] = pair_value;
          }
        }
      });
      return ret;
    },
    /* Key - Value Indexes for IPR totals, even the laterallized ones */
    ipr_lower_totals() {
      let ret = {};
      this.filtered_iprs.forEach((ipr) => {
        const lower_arch_array = ipr.lower_arch_array;
        if (lower_arch_array) {
          for (const key in lower_arch_array) {
            const current = ret[key] || 0.0;
            ret[key] = this.roundIPR(current + (Number(lower_arch_array[key].amount || 0.0)));
          }
        }
      });
      return ret;
    },
    ipr_upper_totals() {
      let ret = {};
      this.filtered_iprs.forEach((ipr) => {
        const upper_arch_array = ipr.upper_arch_array;
        if (upper_arch_array) {
          for (const key in upper_arch_array) {
            const current = ret[key] || 0.0;
            ret[key] = this.roundIPR(current + (Number(upper_arch_array[key].amount || 0.0)));
          }
        }
      });
      return ret;
    },
    ...mapGetters(['clinic', 'msgwindow', 'errorwindow'])
  },
  methods: {
    roundIPR(number) {
      const factor = Math.pow(10, 2);
      return Math.round(number * factor) / factor;
    },
    loadIPRs() {
      this.clearSelected();
      axios.get(`/customer/${this.customer.id}/iprs`).then((response) => {
        this.iprs = response.data;
      }).catch((err) => {
        this.msgwindow.error('Error cargando IPRs. Por favor contacte con el Administrador')
      });
    },
    editIPR(ipr) {
      this.$refs.showipr.showEdit(ipr);
    },
    deleteIPR(ipr) {
      this.errorwindow.show('Confirmación', '¿Borrar el IPR? Esta operación no es reversible.', 'Borrar', 'Cancelar', () => {
        this.doDeleteIPR(ipr);
      })
    },
    doDeleteIPR(ipr) {
      axios.post(`/customer/${this.customer.id}/iprs/${ipr.id}`, {
        '_method': 'delete'
      }).then((response) => {
        this.msgwindow.success('IPR borrado correctamente');
      }).catch((err) => {
        this.msgwindow.error('Error borrando el IPR, consulte con el Administrador');
      }).then(() => {
        this.loadIPRs();
      })
    },
    clickTooth(tooth) {
      this.selected_tooth = tooth;
      this.selected_ipr = null;
    },
    clickIpr(ipr) {
      this.selected_tooth = 0;
      this.selected_ipr = ipr.id;
    },
    clearSelected() {
      this.selected_tooth = 0;
      this.selected_ipr = null;
    },
    isSelected(tooth) {
      return this.selected_tooth == tooth;
    },
    createIPR() {
      this.$refs.showipr.showNew();
    },
  },
  mounted() {
    this.loadIPRs();
  }
}
</script>

<style lang="scss">
.customer-ortho-iprs {
  display: flex;
  flex-flow: column nowrap;
  gap: 30px;
  padding: 30px;

  &__info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 36px;
  }

  &__odontogram {
    width: 100%;
    position: relative;
    display: flex;
    flex-flow: row wrap;
    gap: 45px;

    &:before {
      position: absolute;
      width: 100%;
      height: 1px;
      content: '';
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      background: var(--theme-shadow);
    }

    &:after {
      position: absolute;
      width: 1px;
      height: 100%;
      content: '';
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      background: var(--theme-shadow);
    }
  }

  &__odontogram-row {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1 1 100%;
  }

  &__tooth-totals {
    position: absolute;
    background: var(--theme-grey-bg);
    color: var(--theme-text-color);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3px 7px;
    border: 1px var(--theme-grey) solid;
    border-radius: 10px;
    left: 100%;
    transform: translateX(-50%);
    z-index: 10;
    line-height: 1;
    font-size: clamp(7px, 0.8vw, 15px);

    &.upper {
      bottom: 15px;
    }

    &.lower {
      top: 15px;
    }

    &.lower.left {
      top: -15px;
      left: 100%;
      transform: translateX(calc(-100% - 5px));
      opacity: 0.8;
    }

    &.lower.right {
      top: -15px;
      left: 5px;
      transform: translateX(0);
      opacity: 0.8;
    }

    &.upper.left {
      bottom: -15px;
      left: 100%;
      transform: translateX(calc(-100% - 5px));
      opacity: 0.8;
    }

    &.upper.right {
      bottom: -15px;
      left: 5px;
      transform: translateX(0);
      opacity: 0.8;
    }
  }

  &__odontogram-tooth {
    flex: 1 1 60px;
    position: relative;
    cursor: pointer;
    transition: background-color .3s;
    border-radius: 10px;

    /* Selected background */
    &.selected,
    &:hover {
      background-color: var(--theme-shadow);
    }

    &.selected svg * {
      fill: var(--theme-color);
    }

    /* Tooth image */
    img {
      box-sizing: border-box;
      width: 100%;
      padding: 10%;
      object-fit: contain;
      object-position: center center;
    }

    /* Tooth label */
    &::before {
      content: attr(data-tooth);
      position: absolute;
      left: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 3px;
      color: white;
      font-weight: 900;
      font-size: clamp(7px, 0.7vw, 14px);
      line-height: 1.5;
      padding: 0 5px;
      transform: translateX(-50%);
      background-color: var(--theme-color);
      z-index: 1;
    }

    &.upper::before {
      top: 10px;
    }

    &.lower::before {
      bottom: 10px;
    }
  }

  &__list {
    width: 100%;
    max-height: 50vh;
    overflow-y: scroll;

    table {
      thead {
        position: sticky;
        border-color: var(--theme-color);

        tr {
          background-color: var(--theme-color) !important;

          th {
            color: white;
            text-transform: uppercase;
            background-color: var(--theme-color);
            text-align: center;
            font-size: 15px;
          }
        }
      }

      tbody {
        tr {

          &:hover,
          &.selected {
            background-color: var(--theme-shadow);
          }

          td {
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
